(ns frontend.view.nev.kyc.tenant-kyc-profile.events
  (:require
   [frontend.state.current-session :as session]
   [ui.editors.data-input :as data-input]
   [common.schema.entities.workspace.kyc.kyc-process :as kyc-process]
   [common.util :as cu]
   [common.localization :as loc]
   [frontend.actions.entity :as entity-actions]
   [clojure.set :as set]
   [frontend.routing :as routing]
   [frontend.logging :as logging]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [common.schema.entities.workspace.kyc.templates.templates :as templates]
   [frontend.actions.account :as account-actions]))

(defn create-process!
  [{:keys [entity]}]
  (let [company-id (:tenant-kyc-profile/target entity)
        company (get @session/entities company-id)
        previous-process (some->>
                          entity
                          :tenant-kyc-profile/kyc-processes
                          (map (partial get @session/entities))
                          (sort-by :common/created-on)
                          (last))
        data {:entity/type              :entity.type/kyc-process
              :common/containing-entity (:db/id entity)
              :kyc-process/answers      (when previous-process
                                          (kyc-process/copy-process-answers previous-process))
              :kyc-process/language     (:kyc-process/language previous-process)
              :kyc-process/template     (or
                                         (:kyc-process/template previous-process)
                                         :kyc-template/demo-tenant)
              :kyc-process/inviter      (:tenant-kyc-profile/our-kyc-contact entity)}]
    (entity-actions/*->create
     (cu/remove-nil-vals data)
     (fn [resp]
       (let [process (:body resp)
             process-id (:db/id process)]
         (entity-actions/*->field-update!
          (:db/id entity)
          :tenant-kyc-profile/kyc-processes
          (set/union #{process-id} (set (:tenant-kyc-profile/kyc-processes entity)))
          (fn [ok]
            ;; The new process is not in the session on the new grid, so
            ;; open-entity could not tell its type. Say it.
            (routing/open-entity-type :entity.type/kyc-process process-id))
          (fn [err]
            (logging/error "Failed to add process to profile" err)))))
     (fn [err]
       (logging/error "Could not create KYC process " err)))))


(defn save-answers!
  [process-entity answers-as-str on-success! on-fail!]
  (entity-actions/*->field-update!
   (:db/id process-entity)
   :kyc-process/answers
   answers-as-str
   (fn [resp]
     (on-success! resp))
   (fn [error]
     (on-fail! error))))

(defn delete-category!
  [{:keys [entity-id]}]
  (let [current-state (get @session/entities entity-id)]
    (when (and current-state (not (:common/disabled? current-state)))
      (entity-actions/*->disable! entity-id
                                  (fn [_]
                                    (swap! session/entities dissoc entity-id))
                                  (fn [err]
                                    (logging/error "Failed to disable entity " entity-id
                                                   " -> " err))))))


(defn configure-KYC-categories
  []
  (modals/open-modal!
   dynamic-modal/modal-key
   {:title
    (loc/tr :kyc-profile/risk-category)

    :render-fn
    (fn [modal-state close-modal!]
      [:div
       [:table.zap-simple-table.zap-simple-table--md.w-100
        [:thead.zap-table__head
         [:tr
          [:th (loc/tr :kyc-risk-category/name)]
          [:th (loc/tr :kyc-risk-category/renewal-interval)]
          [:th]]]
        [:tbody
         (->>
          @session/all-kyc-risk-categories
          (remove :common/disabled?)
          (remove :common/archived?)
          ;; no need to filter pipeline specific as this is not pipeline entity
          (sort-by :common/ord)
          (map
           (fn [rc]
             [:tr
              {:key (str "Risk-cagegory-" (:db/id rc))}
              [:td
               [data-input/view
                {:data-type :data.type/text-simple
                 :value     (:kyc-risk-category/name rc)
                 :on-blur   (fn [new-value]
                              (entity-actions/*->field-update!
                               (:db/id rc)
                               :kyc-risk-category/name
                               new-value
                               identity
                               (fn [_err]
                                 (logging/error "Failed to update kyc-risk-category name"))))}]]
              [:td
               [data-input/view
                {:data-type :data.type/integer
                 :value     (:kyc-risk-category/renewal-interval rc)
                 :on-blur   (fn [new-value]
                              (entity-actions/*->field-update!
                               (:db/id rc)
                               :kyc-risk-category/renewal-interval
                               new-value
                               identity
                               (fn [_err]
                                 (logging/error
                                      "Failed to update kyc-risk-category renewal interval"))))}]]
              [:td
               [:i.fal.fa-trash-alt.pointer
                {:on-click (fn [_]
                             (delete-category! {:entity-id (:db/id rc)}))}]]]))
          (doall))]]])}))

(defn save-modules-order!
  [entity-type view-id ordering on-success! on-error!]
  (let [msg {:path      [view-id :modules :ordering]
             :new-value ordering}]
    (account-actions/*->update-view-config
     msg
     (or on-success! identity)
     (or on-error!
         (fn [e]
           (logging/error "Unable to save modules order" e))))))
